<canvas id="canvas" #canvas [width]="OHLC_LENGTH" height="1"> </canvas>
<span #themeElement class="d-none"> </span>
